// extracted by css-extract-rspack-plugin
export default {"quickViewButton":"_38841031"};